import React from "react";
import classes from "../Nochapter/Nochapter.module.css";
const Novideo = () => {
  return (
    <div className={classes["container"]}>
      <p>There is no video to show.Please choose another course and chapter.</p>
    </div>
  );
};

export default Novideo;
